"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var UsrAdminsList_1 = require("./component/UsrAdminsList");
var UsrAdminEditor_1 = require("./component/UsrAdminEditor");
var UsrAdminAccessList_1 = require("./component/UsrAdminAccessList");
var PUsrAdminsList = /** @class */ (function (_super) {
    __extends(PUsrAdminsList, _super);
    function PUsrAdminsList(props) {
        return _super.call(this, props) || this;
    }
    PUsrAdminsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record_key: 0,
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        });
    };
    PUsrAdminsList.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PUsrAdminsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record_key: -1 });
    };
    PUsrAdminsList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", record_key: id });
    };
    PUsrAdminsList.prototype.onAccessClick = function (id) {
        this.setState({ edit_mode: "ACCESS", record_key: id });
    };
    PUsrAdminsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record_key: -1 });
    };
    PUsrAdminsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PUsrAdminsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(UsrAdminEditor_1.default, { data: this.props.data, state: this.props.state, recordKey: -1, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(UsrAdminEditor_1.default, { data: this.props.data, state: this.props.state, recordKey: this.state.record_key, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "ACCESS") {
            return (React.createElement(UsrAdminAccessList_1.default, { dialog: this.props.dlgKeyValueItem, state: this.props.state, recordKey: this.state.record_key, onGoBackClick: this.onGoBackClick.bind(this), availBrandsList: this.props.availBrandsList, availAffilatesList: this.props.availAffilatesList, availGwsGameProvidersList: this.props.availGwsGameProvidersList, dataAccessBrands: this.props.dataAccessBrands, dataAccessAffilates: this.props.dataAccessAffilates, dataAccessGwsGameProvider: this.props.dataAccessGwsGameProvider, availUsrPermissionsList: this.props.availUsrPermissionsList, dataAccessUsrPermissions: this.props.dataAccessUsrPermissions }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(UsrAdminsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onAccessClick: this.onAccessClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, dlgPwd: this.props.dlgPwd, dlgView: this.props.dlgView }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PUsrAdminsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PUsrAdminsList.getPageDescription = function (state) {
        return {
            icon: "users",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_usr_admins + "-id",
            itemTitle: "Сотрудники",
            route: routes_1.routes.page_usr_admins,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PUsrAdminsList;
}(React.Component));
exports.default = PUsrAdminsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_admins_list/ui/PUsrAdminsList.tsx
// module id = 1891
// module chunks = 0